import { createFileRoute } from "@tanstack/react-router";

import { AdminPage } from "@/uiKit/pages/AdminPage.tsx";

export const Route = createFileRoute("/admin/")({
  component: AdminPage,
});
